import { useSyncExternalStore } from 'react';

import { getOperator, subscribeOperator, type OperatorSession } from './operatorToken';

/**
 * Reactive view of the signed-in operator. Re-renders on sign-in, sign-out,
 * or when a 401 from the API drops the session. `null` => show the PIN pad.
 */
export function useOperator(): OperatorSession | null {
  return useSyncExternalStore(subscribeOperator, getOperator, getOperator);
}
